<template>
	<div class='act'>
		<ActHeader/>

		<div class='act__content-container'>
			<div class='act__content'>
				<router-view/>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapGetters, mapMutations, mapActions } from 'vuex';
	import ActHeader from './Act__header';

	export default {
		name: 'LpoDataAct',

		components: {
			ActHeader
		},
		methods: {
			...mapActions("selectedLpo", ["getLpoAll"]),
			...mapMutations("selectedLpo", ["clearLpo"]),
			...mapActions("selectedLpo/recount", ["getRecount"]),
  		},
		created() {
			const lpo_id = this.$route.params["lpo_id"];
			this.getLpoAll(lpo_id).then((res) => {
			this.getRecount();
			});
		},
		beforeDestroy() {
			this.clearLpo();
		},
	};
</script>

<style scoped lang='scss' src='@/style/constants.scss'></style>

<style lang='scss' scoped>
	@import '@/style/constants.scss';

	.act {
		display: flex;
		flex-direction: column;
		height: 100%;
	}

	.act__content-container {
		overflow-y: auto;
		flex: 1;
	}

	.act__content {
		max-width: $wrapper-max-width;
		margin: auto;

		padding: $wrapper-padding;
	}
</style>